import { Filter } from '@elderbyte/ngx-starter'

export class PackageFilterBuilder {
  public static readonly WORK_ORDER_ID = 'workOrderId'
  public static readonly STORAGE_PATH = 'storagePath'
  public static readonly STORAGE_PATH_DEEP = 'storagePathDeep'
  public static readonly PRODUCTION_PATH = 'productionPath'
  public static readonly PRODUCTION_PATHS = 'productionPaths'
  public static readonly PRODUCTION_PATH_WORKCENTER = 'productionPathWorkCenter'

  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private _ids: string[]
  private _workOrderId: string
  private _storagePath: string
  private _storagePathDeep: string
  private _productionPath: string
  private _productionPaths: string[]
  private _productionPathWorkCenter: string

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static ids(...ids: string[]): Filter {
    return this.start()
      .ids(...ids)
      .build()[0]
  }

  public static workOrderId(workOrderId: string): Filter {
    return this.start().workOrderId(workOrderId).build()[0]
  }

  public static storagePath(storagePath: string, deepSearch = false): Filter {
    return this.start().storagePath(storagePath, deepSearch).build()[0]
  }

  /**
   * @param productionPath is actually a WorkItem's productionLinePath
   */
  public static productionPath(productionPath: string): Filter {
    return this.start().productionPath(productionPath).build()[0]
  }

  /**
   * @param productionPaths actually contains WorkItem productionLinePaths
   */
  public static productionPaths(productionPaths: string[]): Filter {
    return this.start().productionPaths(productionPaths).build()[0]
  }

  /**
   * @param productionPaths actually contains WorkItem productionLinePaths
   */
  public static productionPathWorkCenter(productionPathWorkCenter: string): Filter {
    return this.start().productionPathWorkCenter(productionPathWorkCenter).build()[0]
  }

  public static start(): PackageFilterBuilder {
    return new PackageFilterBuilder()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public ids(...ids: string[]): PackageFilterBuilder {
    this._ids = ids
    return this
  }

  public workOrderId(workOrderId: string): PackageFilterBuilder {
    this._workOrderId = workOrderId
    return this
  }

  public storagePath(storagePath: string, deepSearch: boolean): PackageFilterBuilder {
    deepSearch ? (this._storagePath = storagePath) : (this._storagePathDeep = storagePath)
    return this
  }

  /**
   * @param productionPath is actually a WorkItem's productionLinePath
   */
  public productionPath(productionPath: string): PackageFilterBuilder {
    this._productionPath = productionPath
    return this
  }

  /**
   * @param productionPaths actually contains WorkItem productionLinePaths
   */
  public productionPaths(productionPaths: string[]): PackageFilterBuilder {
    this._productionPaths = productionPaths
    return this
  }

  public productionPathWorkCenter(productionPathWorkCenter: string): PackageFilterBuilder {
    this._productionPathWorkCenter = productionPathWorkCenter
    return this
  }

  public build(): Filter[] {
    const filters: Filter[] = []

    if (this._ids) {
      filters.push(new Filter('ids', this._ids))
    }

    if (this._workOrderId) {
      filters.push(new Filter(PackageFilterBuilder.WORK_ORDER_ID, this._workOrderId))
    }

    if (this._storagePath) {
      filters.push(new Filter(PackageFilterBuilder.STORAGE_PATH, this._storagePath))
    }

    if (this._storagePathDeep) {
      filters.push(new Filter(PackageFilterBuilder.STORAGE_PATH_DEEP, this._storagePathDeep))
    }

    if (this._productionPath) {
      filters.push(new Filter(PackageFilterBuilder.PRODUCTION_PATH, this._productionPath))
    }

    if (this._productionPaths && this.productionPaths.length > 0) {
      filters.push(new Filter(PackageFilterBuilder.PRODUCTION_PATHS, this._productionPaths))
    }

    if (this._productionPathWorkCenter) {
      filters.push(
        new Filter(PackageFilterBuilder.PRODUCTION_PATH_WORKCENTER, this._productionPathWorkCenter)
      )
    }

    return filters
  }
}
